import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import { makeGetCurrentTeam } from '../selectors/teams';
import { makeGetSubscriptionIsExpired } from '../selectors/billing';

import { DocumentFocusProvider } from 'context/DocumentFocusContext';

import AppHead from './app-head';

class AppWrap extends PureComponent {
    isOnNonSubscriptionAllowed(loc) {
        return loc.pathname === 'upgrade' || loc.pathname === 'dashboard' || loc.pathname === '/' || loc.pathname.match(/^settings\/(team|profile|notifications|apps)/);
    }

    attemptRedirect() {
        if (this.props.isExpired && !this.isOnNonSubscriptionAllowed(this.props.history.getCurrentLocation())) {
            this.props.history.push({
                pathname: '/dashboard'
            });
        }
    }

    componentDidMount() {
        this.props.history.listenBefore(loc => {
            if (this.props.isExpired && !this.isOnNonSubscriptionAllowed(loc)) {
                return false;
            }

            return true;
        });

        this.attemptRedirect();
    }

    componentDidUpdate(prevProps) {
        if (this.props.isExpired !== prevProps.isExpired) {
            this.attemptRedirect();
        }
    }

    render() {
        return (
            <DocumentFocusProvider>
                <AppHead history={this.props.history} />

                <div className="app-wrap-inner">
                    <div className="app">{ this.props.children }</div>
                </div>
            </DocumentFocusProvider>
        );
    }
}

const makeMapStateToProps = () => {
    const getCurrentTeam = makeGetCurrentTeam();
    const getSubscriptionIsExpired = makeGetSubscriptionIsExpired();

    return ({ teams }) => {
        const currentTeam = getCurrentTeam(teams);

        return {
            isExpired: getSubscriptionIsExpired(currentTeam)
        }
    };
};

export default connect(makeMapStateToProps)(AppWrap);

